export const TagEntities = {
  RESOURCE: "resource",
  FINDING: "finding",
} as const;

export type TagEntity = (typeof TagEntities)[keyof typeof TagEntities];

export const TagTypes = {
  MANUAL: "MANUAL",
  DATA_SOURCE: "DATA_SOURCE",
  SEEM: "SEEM",
} as const;

export type TagType = (typeof TagTypes)[keyof typeof TagTypes];

export const TagIcons = {
  MANUAL: "seem-icon-manual",
  SEEM: "seem-icon-seemplicity-mark",
} as const;

export type TagIcon = (typeof TagIcons)[keyof typeof TagIcons];
